class CustomLogin {
  el;
  siteHeader;

  constructor(customLogin) {
    this.el = customLogin;
    this.siteHeader = document.getElementById("site-header");

    this.init();
  }

  init() {
    if (this.siteHeader) {
      this.siteHeader.classList.add("contrast");
    }
  }
}

const customLogin = document.getElementById("custom-login");
if (customLogin) {
  new CustomLogin(customLogin);
}
